import { useTranslation } from "react-i18next";
import { Avatar } from "@unified-checkout/design-system";
import { ArrowRightFromBracket } from "@unified-checkout/design-system/icons/index";
import type { IAccountBar, IImgAccountBar, ITextAccountBar } from "@app/dashboard/types/innerLayout/account-bar";
import styles from "./account-bar.module.scss";

export const AccountBar = (props: IAccountBar) => {
  const { t } = useTranslation();

  const { collapsed = false, handlers, role, mId, staffId, type = "placeholder", userName } = props;

  const { logout, editProfile, toggleAccountBox } = handlers;

  let content = <></>;

  if (type === 'img') {
    const { imgUrl } = props as IImgAccountBar;

    content = <Avatar
      type="img"
      imgUrl={imgUrl}
      name={userName}
      focusable={collapsed}
    />
  } else if (type === 'text') {
    const { userShortName } = props as ITextAccountBar;

    content = <Avatar
      type="text"
      shortName={userShortName}
      focusable={collapsed}
    />
  } else {
    content = <Avatar
      focusable={collapsed}
    />
  }

  return (
    <div className={styles["account-bar"]}>
      <div className={styles["account-bar__avatar"]}
        data-account-bar-avatar-type={type}
        onClick={collapsed ? toggleAccountBox : editProfile}
      >
        {content}
      </div>

      {
        !collapsed &&
        <>
          <div className={styles["account-bar__info"]} onClick={editProfile}>
            <div
              className={styles["account-bar__info__name"]}
              title={userName}
            >
              {userName}
            </div>
            {
              mId &&
              <div
                className={styles["account-bar__info__supporting-info"]}
                title={`${t('innerLayout.mid')}: ${mId}`}
              >
                {`${t('innerLayout.mid')}: ${mId}`}
              </div>
            }
            {
              staffId !== mId &&
              <div
                className={styles["account-bar__info__supporting-info"]}
                title={`${t('innerLayout.staffId')}: ${staffId}`}
              >
                {`${t('innerLayout.staffId')}: ${staffId}`}
              </div>
            }
          </div>

          <div className={styles["account-bar__logout"]} onClick={logout}>
            {ArrowRightFromBracket}
          </div>
        </>
      }
    </div>
  )
};